import API from "../../../apis/contextmeeting/api"
import { displayUserMessageAction } from "../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../userMessage/state/userMessageTypes"
import { normalize } from "normalizr"
import { call, put, takeLeading } from "redux-saga/effects"
import { withAuthHeader } from "../../../apis/contextmeeting/withAuthHeader"
import queryString from "query-string"
import humps from "humps"
import { ChatMessagesActionTypes, IFetchChatMessagesAsyncAction } from "./messagesTypes"
import { fetchMessagesSchema } from "../../../apis/contextmeeting/schema"

export function* fetchChatMessagesAsync(action: IFetchChatMessagesAsyncAction): Generator {
  try {
    const query = queryString.stringify(humps.decamelizeKeys(action.payload.searchQuery), { arrayFormat: "bracket" })
    const response: any = yield call(API.get, `/chats/${action.payload.chatId}/messages?${query}`, withAuthHeader())
    const normalizedResponse = normalize(response.data.all, [fetchMessagesSchema])

    yield put({
      type: ChatMessagesActionTypes.FETCH_CHAT_MESSAGES_ASYNC_SUCCESS,
      payload: {
        chatId: action.payload.chatId,
        all: normalizedResponse,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        resultsPerPage: response.data.searchQuery.resultsPerPage
      }
    })
  } catch (error) {
    yield put({
      type: ChatMessagesActionTypes.FETCH_CHAT_MESSAGES_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "messagesNotFound",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* watchFetchChatMessagesAsync(): Generator {
  yield takeLeading(ChatMessagesActionTypes.FETCH_CHAT_MESSAGES_ASYNC_PENDING, fetchChatMessagesAsync)
}
